export const WIDGET_TYPES = {

  timeseries: {
    label: 'Zeitreihen-Diagramm',
    icon: '📈',
    defaultFqn: 'system.time_series_chart',
    defaultType: 'timeseries',
    imageSearch: 'Time series chart',
    defaultSettings: { showLegend: true, legendConfig: { direction: 'column', position: 'bottom', showAvg: true, showMin: false, showMax: false, showTotal: false, showLatest: false } },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    multiKey: true,
    hasKeyLabels: true,
  },
  lineChart: {
    label: 'Liniendiagramm',
    icon: '📉',
    defaultFqn: 'system.line_chart',
    defaultType: 'timeseries',
    imageSearch: 'Line chart',
    defaultSettings: { showLegend: true, legendConfig: { direction: 'column', position: 'bottom', showAvg: true, showMin: false, showMax: false, showTotal: false, showLatest: false } },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    multiKey: true,
    hasKeyLabels: true,
  },
  barChart: {
    label: 'Balkendiagramm',
    icon: '📊',
    defaultFqn: 'system.bar_chart',
    defaultType: 'timeseries',
    imageSearch: 'Bar chart',
    defaultSettings: { showLegend: true, legendConfig: { direction: 'column', position: 'bottom', showAvg: true, showMin: false, showMax: false, showTotal: false, showLatest: false } },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    multiKey: true,
    hasKeyLabels: true,
  },
  pointChart: {
    label: 'Punktdiagramm',
    icon: '⚫',
    defaultFqn: 'system.point_chart',
    defaultType: 'timeseries',
    imageSearch: 'Point chart',
    defaultSettings: { showLegend: true, legendConfig: { direction: 'column', position: 'bottom', showAvg: true, showMin: false, showMax: false, showTotal: false, showLatest: false } },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    multiKey: true,
    hasKeyLabels: true,
  },
  stateChart: {
    label: 'Zustandsdiagramm',
    icon: '🔄',
    defaultFqn: 'system.state_chart',
    defaultType: 'timeseries',
    imageSearch: 'State chart',
    defaultSettings: { showLegend: true, legendConfig: { direction: 'column', position: 'right', showAvg: false, showMin: false, showMax: false, showTotal: false, showLatest: false } },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    hasKeyLabels: true,
    hasStateValues: true,
  },
  pieChart: {
    label: 'Kreisdiagramm',
    icon: '🥧',
    defaultFqn: 'system.pie',
    defaultType: 'latest',
    imageSearch: 'Pie',
    defaultSettings: { showLegend: true },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    multiKey: true,
    hasKeyLabels: true,
  },
  doughnutChart: {
    label: 'Ringdiagramm',
    icon: '🍩',
    defaultFqn: 'system.doughnut',
    defaultType: 'latest',
    imageSearch: 'Doughnut',
    defaultSettings: { showLegend: true },
    fields: [
      { key: 'showLegend', label: 'Legende anzeigen', type: 'checkbox', default: true },
    ],
    multiKey: true,
    hasKeyLabels: true,
  },
  gauge: {
    label: 'Radialanzeige',
    icon: '⏱️',
    defaultFqn: 'system.analogue_gauges.radial_gauge_canvas_gauges',
    defaultType: 'latest',
    imageSearch: 'Radial gauge',
    defaultSettings: { minValue: 0, maxValue: 100, showBorder: true, animation: true, animationDuration: 500 },
    fields: [
      { key: 'minValue', label: 'Minimum', type: 'number', default: 0 },
      { key: 'maxValue', label: 'Maximum', type: 'number', default: 100 },
      { key: 'unitTitle', label: 'Einheitentitel', type: 'text', default: '' },
      { key: 'units', label: 'Einheiten', type: 'text', default: '' },
    ],
  },

  valueCard: {
    label: 'Wertkarte',
    icon: '🔢',
    defaultFqn: 'system.cards.value_card',
    defaultType: 'latest',
    imageSearch: 'Value card',
    defaultSettings: {},
    fields: [
      { key: 'decimals', label: 'Dezimalstellen', type: 'number', default: 0, min: 0, max: 10 },
    ],
    hasKeyUnit: true,
  },
  horizontalValueCard: {
    label: 'Horizontale Wertkarte',
    icon: '↔️',
    defaultFqn: 'system.cards.horizontal_value_card',
    defaultType: 'latest',
    imageSearch: 'Horizontal value card',
    defaultSettings: {},
    fields: [
      { key: 'decimals', label: 'Dezimalstellen', type: 'number', default: 0, min: 0, max: 10 },
    ],
    hasKeyUnit: true,
  },
  labelCard: {
    label: 'Beschriftungskarte',
    icon: '🏷️',
    defaultFqn: 'system.label_card',
    defaultType: 'static',
    imageSearch: 'Label card',
    defaultSettings: {},
    fields: [],
    noDatasource: true,
  },
  labelValueCard: {
    label: 'Beschriftung & Wert',
    icon: '🏷️',
    defaultFqn: 'system.label_value_card',
    defaultType: 'latest',
    imageSearch: 'Label & value card',
    defaultSettings: {},
    fields: [
      { key: 'decimals', label: 'Dezimalstellen', type: 'number', default: 0, min: 0, max: 10 },
    ],
    hasKeyUnit: true,
  },
  attributesCard: {
    label: 'Attribute',
    icon: '📋',
    defaultFqn: 'system.cards.attributes_card',
    defaultType: 'latest',
    imageSearch: 'Attributes card',
    defaultSettings: {},
    fields: [],
    multiKey: true,
    noTitle: true,
  },
  signalStrength: {
    label: 'Signalstärke',
    icon: '📶',
    defaultFqn: 'system.signal_strength',
    defaultType: 'latest',
    imageSearch: 'Signal strength',
    defaultSettings: {},
    fields: [],
    fixedKey: 'rssi',
  },

  alarm: {
    label: 'Alarme',
    icon: '🚨',
    defaultFqn: 'system.alarm_widgets.alarms_table',
    defaultType: 'alarm',
    imageSearch: 'Alarms table',
    fields: [
      {
        key: 'severityList', label: 'Schweregrad', type: 'multiselect',
        options: [
          { value: 'CRITICAL', label: 'Kritisch' },
          { value: 'MAJOR', label: 'Schwer' },
          { value: 'MINOR', label: 'Leicht' },
          { value: 'WARNING', label: 'Warnung' },
          { value: 'INDETERMINATE', label: 'Unbestimmt' },
        ],
        default: [],
      },
      {
        key: 'statusList', label: 'Status', type: 'multiselect',
        options: [
          { value: 'ACTIVE_UNACK', label: 'Aktiv (unbestätigt)' },
          { value: 'ACTIVE_ACK', label: 'Aktiv (bestätigt)' },
          { value: 'CLEARED_UNACK', label: 'Gelöscht (unbestätigt)' },
          { value: 'CLEARED_ACK', label: 'Gelöscht (bestätigt)' },
        ],
        default: [],
      },
    ],
    noDatasource: true,
  },
  table: {
    label: 'Zeitreihen-Tabelle',
    icon: '📋',
    defaultFqn: 'system.cards.timeseries_table',
    defaultType: 'timeseries',
    imageSearch: 'Timeseries table',
    defaultSettings: { enableSearch: true, displayPagination: true, defaultPageSize: 10, showTimestamp: true, sortOrder: { property: 'createdTime', direction: 'DESC' } },
    fields: [],
    multiKey: true,
    hasKeyLabels: true,
  },
};


export const WIDGET_CATEGORIES = [
  {
    key: 'charts',
    label: 'Diagramme',
    icon: '📈',
    widgets: ['timeseries', 'lineChart', 'barChart', 'pointChart', 'stateChart', 'pieChart', 'doughnutChart', 'gauge'],
  },
  {
    key: 'cards',
    label: 'Karten',
    icon: '🃏',
    widgets: ['valueCard', 'horizontalValueCard', 'labelCard', 'labelValueCard', 'attributesCard', 'signalStrength'],
  },
  {
    key: 'tables',
    label: 'Tabellen',
    icon: '📋',
    widgets: ['alarm', 'table'],
  },
];


export function buildTbWidgetConfig(editorWidget) {
  const typeDef = WIDGET_TYPES[editorWidget.widgetType];
  if (!typeDef) return null;

  const datasources = [];
  const _titleAsLabel = ['valueCard', 'horizontalValueCard'].includes(editorWidget.widgetType);
  if (!typeDef.noDatasource && editorWidget.deviceId) {
    const dataKeys = (editorWidget.keys || []).map((k, kIdx) => ({
      name: k,
      label: (_titleAsLabel && kIdx === 0)
        ? (editorWidget.title || k)
        : (editorWidget.keyLabels?.[k] || k),
      type: 'timeseries',
      color: '#2196f3',
      settings: editorWidget.keyUnits?.[k] ? { units: editorWidget.keyUnits[k] } : {},
    }));
    datasources.push({
      type: 'device',
      name: '',
      deviceId: editorWidget.deviceId,
      dataKeys,
      latestDataKeys: [],
      alarmFilterConfig: { statusList: ['ACTIVE'] },
    });
  }


  const settings = { ...(typeDef.defaultSettings || {}) };
  for (const field of typeDef.fields) {
    const val = editorWidget.settings?.[field.key];
    if (val !== undefined) {
      settings[field.key] = val;
    } else {
      settings[field.key] = field.default;
    }
  }

  if (editorWidget.stateValues?.length) {
    const _n = editorWidget.stateValues.length;
    const _stateData = editorWidget.stateValues.map((sv, idx) => {
      const _isNum = !isNaN(Number(sv.value)) && sv.value !== '';
      return {
        value: _isNum ? Number(sv.value) : sv.value,
        label: sv.label || `State ${idx + 1}`,
        color: `hsl(${(idx * 137.5) % 360}, 65%, 55%)`,
        type: _isNum ? 'integer' : 'string',
        tickValue: _n > 1 ? idx / (_n - 1) : 0,
      };
    });
    settings.stateData = _stateData;
    settings.states = editorWidget.stateValues.map((sv, idx) => ({
      label: sv.label || `State ${idx + 1}`,
      value: _n > 1 ? idx / (_n - 1) : 0,
      sourceType: 'constant',
      sourceValue: !isNaN(Number(sv.value)) && sv.value !== '' ? Number(sv.value) : sv.value,
    }));
    // Also store per-dataKey (ThingsBoard state_chart reads from there)
    if (datasources[0]?.dataKeys?.length) {
      datasources[0].dataKeys[0].settings = {
        ...(datasources[0].dataKeys[0].settings || {}),
        stateData: _stateData,
      };
    }
  }

  if (editorWidget.widgetType === 'labelCard') {
    settings.label = editorWidget.title || '';
    settings.showIcon = false;
  }

  if (typeDef.hasKeyUnit) {
    const firstKey = editorWidget.keys?.[0];
    const unit = (firstKey && editorWidget.keyUnits?.[firstKey]) || '';
    if (unit) settings.units = unit;
    settings.label = editorWidget.title || typeDef.label;
    settings.showIcon = false;
  }

  const config = {
    title: editorWidget.title || typeDef.label,
    showTitle: true,
    backgroundColor: 'rgba(0, 0, 0, 0)',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '0px',
    datasources,
    settings,
    dropShadow: true,
    enableFullscreen: true,
    useDashboardTimewindow: typeDef.defaultType === 'timeseries',
    widgetStyle: {},
    actions: {},
    configMode: 'basic',
  };


  if (typeDef.hasKeyUnit) {
    const firstKey = editorWidget.keys?.[0];
    config.units = (firstKey && editorWidget.keyUnits?.[firstKey]) || null;
  }

  if (['labelCard', 'valueCard', 'horizontalValueCard'].includes(editorWidget.widgetType)) {
    config.title = '';
    config.showTitle = false;
  }

  if (['table', 'gauge', 'attributesCard'].includes(editorWidget.widgetType)) {
    config.backgroundColor = 'rgba(255, 255, 255, 1)';
  }


  if (typeDef.defaultType === 'alarm') {
    delete config.datasources;
    config.useDashboardTimewindow = false;
    if (editorWidget.deviceId) {
      config.alarmSource = {
        type: 'device',
        name: '',
        deviceId: editorWidget.deviceId,
        dataKeys: [],
        alarmFilterConfig: { statusList: ['ACTIVE'] },
      };
    }
    config.alarmFilterConfig = { statusList: [], severityList: [], typeList: [] };
    if (settings.severityList?.length) config.alarmFilterConfig.severityList = settings.severityList;
    if (settings.statusList?.length) config.alarmFilterConfig.statusList = settings.statusList;

    delete settings.severityList;
    delete settings.statusList;
  }

  return {
    typeFullFqn: typeDef.defaultFqn,
    type: typeDef.defaultType,
    config,
  };
}

export function detectEditorType(tbWidget) {
  const fqn = tbWidget.typeFullFqn || '';
  const type = tbWidget.type || '';

  if (fqn === 'system.alarm_widgets.alarms_table' || type === 'alarm') return 'alarm';
  if (fqn === 'system.analogue_gauges.radial_gauge_canvas_gauges' || fqn.includes('analogue') || fqn.includes('gauge')) return 'gauge';
  if (fqn === 'system.doughnut' || fqn.includes('doughnut') || fqn.includes('donut')) return 'doughnutChart';
  if (fqn === 'system.pie' || fqn === 'system.charts.pie_chart') return 'pieChart';
  if (fqn === 'system.state_chart' || fqn.includes('state_chart')) return 'stateChart';
  if (fqn === 'system.point_chart' || fqn.includes('point_chart')) return 'pointChart';
  if (fqn === 'system.bar_chart' || fqn.includes('bar_chart') || fqn.includes('basic_bar')) return 'barChart';
  if (fqn === 'system.line_chart' || fqn.includes('line_chart')) return 'lineChart';
  if (fqn === 'system.time_series_chart' || fqn.includes('time_series') || fqn.includes('timeseries') || fqn.includes('flot') || fqn.includes('basic_timeseries')) return 'timeseries';
  if (fqn === 'system.cards.timeseries_table' || fqn === 'system.cards.entities_table' || (fqn.includes('table') && !fqn.includes('alarm'))) return 'table';
  if (fqn === 'system.signal_strength' || fqn.includes('signal_strength')) return 'signalStrength';
  if (fqn === 'system.cards.attributes_card' || fqn.includes('attributes_card')) return 'attributesCard';
  if (fqn === 'system.label_value_card' || fqn.includes('label_value')) return 'labelValueCard';
  if (fqn === 'system.label_card' || fqn === 'system.cards.label_card' || (type === 'static' && fqn.includes('label'))) return 'labelCard';
  if (fqn === 'system.cards.horizontal_value_card' || fqn.includes('horizontal')) return 'horizontalValueCard';
  if (type === 'timeseries') return 'timeseries';
  return 'valueCard';
}


export function tbWidgetToEditor(id, tbWidget, layout) {
  const editorType = detectEditorType(tbWidget);
  const ds = tbWidget.config?.datasources?.[0];
  const keys = (ds?.dataKeys || []).map(dk => dk.name);
  const keyUnits = {};
  const keyLabels = {};
  for (const dk of (ds?.dataKeys || [])) {
    const u = dk.settings?.units || dk.units;
    if (u) keyUnits[dk.name] = u;
    if (dk.label && dk.label !== dk.name) keyLabels[dk.name] = dk.label;
  }

  const deviceId = ds?.deviceId || '';

  const settings = {};
  const tbSettings = tbWidget.config?.settings || {};
  const typeDef = WIDGET_TYPES[editorType];
  if (typeDef) {
    for (const field of typeDef.fields) {
      if (tbSettings[field.key] !== undefined) {
        settings[field.key] = tbSettings[field.key];
      }
    }
  }


  const _stateDataSrc =
    tbSettings.stateData ||
    ds?.dataKeys?.[0]?.settings?.stateData ||
    [];
  const stateValues = _stateDataSrc.map(s => ({
    label: s.label || '',
    value: String(s.value ?? ''),
  }));


  if (typeDef?.hasKeyUnit && keys.length > 0 && !keyUnits[keys[0]]) {
    const u = tbWidget.config?.units || tbSettings.units;
    if (u) keyUnits[keys[0]] = u;
  }

  const widgetTitle =
    (typeDef?.hasKeyUnit && tbSettings.label)
      ? tbSettings.label
      : (editorType === 'labelCard' && tbSettings.label)
        ? tbSettings.label
        : (tbWidget.config?.title || '');

  return {
    id,
    widgetType: editorType,
    title: widgetTitle,
    deviceId,
    keys,
    keyUnits,
    keyLabels,
    settings,
    stateValues,
    layout: {
      x: layout?.col ?? 0,
      y: layout?.row ?? 0,
      w: layout?.sizeX ?? 6,
      h: layout?.sizeY ?? 3,
    },
    _tbOriginal: tbWidget,
  };
}


export function editorWidgetToTb(editorWidget) {
  if (!editorWidget._tbOriginal) {
    return buildTbWidgetConfig(editorWidget);
  }

  const tb = JSON.parse(JSON.stringify(editorWidget._tbOriginal));
  const config = tb.config || (tb.config = {});


  config.title = editorWidget.title;

  const typeDef = WIDGET_TYPES[editorWidget.widgetType];

  if (['labelCard', 'valueCard', 'horizontalValueCard'].includes(editorWidget.widgetType)) {
    config.title = '';
    config.showTitle = false;
  }

  if (['table', 'gauge', 'attributesCard'].includes(editorWidget.widgetType)) {
    config.backgroundColor = 'rgba(255, 255, 255, 1)';
  }
  if (!typeDef?.noDatasource && editorWidget.deviceId) {
    const _titleAsLabelEx = ['valueCard', 'horizontalValueCard'].includes(editorWidget.widgetType);
    const dataKeys = (editorWidget.keys || []).map((k, kIdx) => {
      const existing = config.datasources?.[0]?.dataKeys?.find(dk => dk.name === k);
      const dk = existing
        ? { ...existing }
        : { name: k, label: k, type: tb.type === 'alarm' ? 'alarm' : 'timeseries', settings: {} };
      if (editorWidget.keyLabels?.[k]) {
        dk.label = editorWidget.keyLabels[k];
      }
      if (_titleAsLabelEx && kIdx === 0) {
        dk.label = editorWidget.title || dk.label;
      }
      if (editorWidget.keyUnits?.[k]) {
        dk.settings = { ...(dk.settings || {}), units: editorWidget.keyUnits[k] };
      }
      return dk;
    });

    if (config.datasources?.length) {
      config.datasources[0].type = 'device';
      config.datasources[0].deviceId = editorWidget.deviceId;
      config.datasources[0].dataKeys = dataKeys;
      // Remove legacy alias fields if present
      delete config.datasources[0].entityAliasId;
    } else {
      config.datasources = [{
        type: 'device',
        deviceId: editorWidget.deviceId,
        dataKeys,
        latestDataKeys: [],
        name: '',
      }];
    }
  }


  if (typeDef && editorWidget.settings) {
    if (!config.settings) config.settings = {};
    for (const field of typeDef.fields) {
      if (editorWidget.settings[field.key] !== undefined) {
        config.settings[field.key] = editorWidget.settings[field.key];
      }
    }
  }

  if (editorWidget.stateValues?.length) {
    if (!config.settings) config.settings = {};
    const _n = editorWidget.stateValues.length;
    const _stateData = editorWidget.stateValues.map((sv, idx) => {
      const _isNum = !isNaN(Number(sv.value)) && sv.value !== '';
      return {
        value: _isNum ? Number(sv.value) : sv.value,
        label: sv.label || `State ${idx + 1}`,
        color: `hsl(${(idx * 137.5) % 360}, 65%, 55%)`,
        type: _isNum ? 'integer' : 'string',
        tickValue: _n > 1 ? idx / (_n - 1) : 0,
      };
    });
    config.settings.stateData = _stateData;
    config.settings.states = editorWidget.stateValues.map((sv, idx) => ({
      label: sv.label || `State ${idx + 1}`,
      value: _n > 1 ? idx / (_n - 1) : 0,
      sourceType: 'constant',
      sourceValue: !isNaN(Number(sv.value)) && sv.value !== '' ? Number(sv.value) : sv.value,
    }));
    // Also store per-dataKey (ThingsBoard state_chart reads from there)
    if (config.datasources?.[0]?.dataKeys?.length) {
      config.datasources[0].dataKeys[0].settings = {
        ...(config.datasources[0].dataKeys[0].settings || {}),
        stateData: _stateData,
      };
    }
  }

  if (editorWidget.widgetType === 'labelCard') {
    if (!config.settings) config.settings = {};
    config.settings.label = editorWidget.title;
    config.settings.showIcon = false;
  }

  if (typeDef?.hasKeyUnit) {
    const firstKey = editorWidget.keys?.[0];
    const unit = (firstKey && editorWidget.keyUnits?.[firstKey]) || '';
    if (!config.settings) config.settings = {};
    if (unit) {
      config.units = unit;
      config.settings.units = unit;
    }
    config.settings.label = editorWidget.title;
    config.settings.showIcon = false;
  }

  return tb;
}
